import { User } from "../types/User";
import config from "../config";
import { requests } from ".";

const subdomainUser = "/users";

export enum UserAccountType {
  Agency = "agency",
  Account = "account",
}

export enum UserRoleType {
  Admin = "admin",
  User = "user",
  Owner = "owner",
}

export enum SearchSortFields {
  dateAdded = "dateAdded",
}

export enum SearchSortDirection {
  asc = "asc",
  desc = "desc",
}

interface SearchUserParams {
  companyId?: string
  locationId?: string
  query?: string
  limit?: number
  skip?: number
  type?: UserAccountType
  role?: UserRoleType
  ids?: string
  sort?: SearchSortFields
  sortDirection?: SearchSortDirection
}

export const UserService = {
  getUsers: () => requests().get<{ users: User[] }>("/todos"),

  getUserById: async (userId: string) => {
    if (!userId) throw new Error('Invalid User ID');
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
      `${subdomainUser}/${userId}`
    );
    return data;
  },

  searchUser: (params: SearchUserParams) => {
    return requests(config.MARKETPLACE_REST_API_URL).get(`${subdomainUser}/search`, { params })
  }
};
